import type { PageBlockDefinition } from '../definition-types'

export const inlineFeatureDefinition: PageBlockDefinition = {
  type: 'inline-feature',
  label: 'Inline Feature',
  description: 'Single article with dominant text on the left and a companion image on the right.',
  rowCompatible: true,
  columnCompatible: true,
  category: 'editorial',
  minArticles: 1,
  maxArticles: 1,
  slots: [{ name: 'lead', label: 'Lead Story', required: true }],
  defaultConfig: {
    showImage: true,
    imageSide: 'right',
    showSummary: true,
  },
  editorFields: [
    { key: 'showImage', label: 'Show Image', type: 'toggle' },
    {
      key: 'imageSide',
      label: 'Image Side',
      type: 'select',
      options: [
        { label: 'Right', value: 'right' },
        { label: 'Left', value: 'left' },
      ],
    },
    { key: 'showSummary', label: 'Show Summary', type: 'toggle' },
  ],
}
